<template>
  <div>
    <span style="color: #aaaaaa">（绑定VR设备后，该用户可对VR端发布示教或考试）</span>
    <el-button type="info" size="small" @click="dialogFormVisible = true">添加绑定</el-button>
    <p></p>
    <el-table :data="device_list" style="width:60%" border empty-text = "暂未绑定VR设备，请添加" v-loading="loading">
            <el-table-column label="设备ID" prop="device_id" width="100"></el-table-column>
            <el-table-column label="绑定时间" prop="created_at_str"></el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="delVrDevice(scope.row)">解除绑定</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- Form -->
    <el-dialog title="添加绑定" :visible.sync="dialogFormVisible" center>
      <el-form :model="form" :rules="rules" ref="bindForm" >
        <el-form-item label="设备ID" :label-width="formLabelWidth" prop="device_ids">
          <el-input type="textarea" :rows="5" v-model="form.device_ids" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="addDevice('bindForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      required: true,
      type: Array,
    },
    product_id: {
      required: true,
    },
    customer_id: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      formLabelWidth: "100px",
      rules: {
        device_ids: [
          { 
            required: true, 
            message: "请输入设备ID",
            trigger: "blur" 
          },
        ],
      },
      device_list: [],
      form: {
        device_ids: '',
      },
      device_ids: '',
      dialogFormVisible: false,
    };
  },
  created() {
    this.device_list = this.list;
  },
  methods: {
    emit(){
      this.$emit('changeDevice', this.device_list);
    },
    /**
     * 解除绑定
     * */
    delVrDevice(row) {
      this.$confirm('确定要将设备[' + row.device_id + ']解除绑定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.device_list = this.device_list.filter((item, i) => item.device_id !== row.device_id);
          this.emit();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeForm() {
      this.resetForm('bindForm');
      this.dialogFormVisible = false;
    },
    addDevice(formName) {
      let device_ids = this.form.device_ids.split("\n");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          device_ids.forEach( device_id => {
            if(device_id){
              // 检查数组中是否已经存在相同元素
              const existingItem = this.device_list.find(
                (item) => item.device_id === device_id
              );
              if(!existingItem){
                this.device_list.push({
                  device_id: device_id,
                  created_at_str: this.updateTime(),
                  created_at: Math.floor(new Date().getTime() / 1000),
                })
              }
            }
          });
          this.closeForm();
          this.emit();          
        }
      });
    },

    updateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/order/vr/deviceBind.vue